// extracted by mini-css-extract-plugin
export default {"dialog-title":"multip-page-modal_dialog-title__0rfam","dialog-footer":"multip-page-modal_dialog-footer__qavTG"};